
;(function seibertronDirtpawGalleryRestore20260713() {
  var handle = 'seibertron-youth-dirtpaw-unisex-bmx-mx-atv-mtb-racing-mountain-bike-bicycle-cycling-off-road-dirt-bike-gloves-road-racing-motorcycle-motocross-sports-gloves-touch-recognition-full-finger-glove';
  var chartFile = 'dirtpaw-adult-youth-size-chart-user-20260724-v4.png';
  var entries = [
    {
        "id": "33374834884798",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-01.jpg?v=1783400611",
        "alt": "color:Black | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 01"
    },
    {
        "id": "33374834917566",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-02.jpg?v=1783400611",
        "alt": "color:Black | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 02"
    },
    {
        "id": "33374834950334",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-03.jpg?v=1783400610",
        "alt": "color:Black | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 03"
    },
    {
        "id": "33374834983102",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-04.jpg?v=1783400611",
        "alt": "color:Black | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 04"
    },
    {
        "id": "33374835015870",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-05.jpg?v=1783400611",
        "alt": "color:White | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 05"
    },
    {
        "id": "33374835048638",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-06.jpg?v=1783400611",
        "alt": "color:White | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 06"
    },
    {
        "id": "33374835081406",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-07.jpg?v=1783400611",
        "alt": "color:White | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 07"
    },
    {
        "id": "33374835114174",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-08.jpg?v=1783400611",
        "alt": "color:White | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 08"
    },
    {
        "id": "33374835146942",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-09.jpg?v=1783400610",
        "alt": "color:Red | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 09"
    },
    {
        "id": "33374835179710",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-10.jpg?v=1783400611",
        "alt": "color:Red | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 10"
    },
    {
        "id": "33374835212478",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-11.jpg?v=1783400611",
        "alt": "color:Red | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 11"
    },
    {
        "id": "33374835245246",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-12.jpg?v=1783400611",
        "alt": "color:Red | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 12"
    },
    {
        "id": "33374835278014",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-13.jpg?v=1783400611",
        "alt": "color:Fluorescent Yellow | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 13"
    },
    {
        "id": "33374835310782",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-14.jpg?v=1783400611",
        "alt": "color:Fluorescent Yellow | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 14"
    },
    {
        "id": "33374835343550",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-15.jpg?v=1783400611",
        "alt": "color:Fluorescent Yellow | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 15"
    },
    {
        "id": "33374835376318",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-16.jpg?v=1783400611",
        "alt": "color:Fluorescent Yellow | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 16"
    },
    {
        "id": "33374835409086",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-17.jpg?v=1783400611",
        "alt": "color:Blue | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 17"
    },
    {
        "id": "33374835441854",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-18.jpg?v=1783400611",
        "alt": "color:Blue | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 18"
    },
    {
        "id": "33374835474622",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-19.jpg?v=1783400610",
        "alt": "color:Blue | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 19"
    },
    {
        "id": "33374835507390",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-20.jpg?v=1783400611",
        "alt": "color:Blue | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 20"
    },
    {
        "id": "33374835540158",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-21.jpg?v=1783400611",
        "alt": "color:Orange | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 21"
    },
    {
        "id": "33374835572926",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-22.jpg?v=1783400611",
        "alt": "color:Orange | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 22"
    },
    {
        "id": "33374835605694",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-23.jpg?v=1783400611",
        "alt": "color:Orange | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 23"
    },
    {
        "id": "33374835638462",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-24.jpg?v=1783400611",
        "alt": "color:Orange | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 24"
    },
    {
        "id": "33374835671230",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/dirtpaw-full-finger-gallery-25.jpg?v=1783400611",
        "alt": "color:all | Seibertron Dirtpaw full finger motocross and off-road riding gloves image 25"
    }
];
  var groups = {
    "Black": [
        "33374834884798",
        "33374834917566",
        "33374834950334",
        "33374834983102",
        "33374835671230"
    ],
    "White": [
        "33374835015870",
        "33374835048638",
        "33374835081406",
        "33374835114174",
        "33374835671230"
    ],
    "Red": [
        "33374835146942",
        "33374835179710",
        "33374835212478",
        "33374835245246",
        "33374835671230"
    ],
    "Fluorescent Yellow": [
        "33374835278014",
        "33374835310782",
        "33374835343550",
        "33374835376318",
        "33374835671230"
    ],
    "Blue": [
        "33374835409086",
        "33374835441854",
        "33374835474622",
        "33374835507390",
        "33374835671230"
    ],
    "Orange": [
        "33374835540158",
        "33374835572926",
        "33374835605694",
        "33374835638462",
        "33374835671230"
    ]
};
  var entryById = {};
  var aliases = { 'fluorescent orange': 'Orange', 'orange': 'Orange', 'klein blue': 'Blue', 'blue': 'Blue' };
  entries.forEach(function (entry) { entryById[entry.id] = entry; });

  function section() { return document.querySelector('.auto-product[data-product-handle="' + handle + '"]'); }
  function absolute(url) { if (!url) return ''; if (url.indexOf('//') === 0) return window.location.protocol + url; if (url.charAt(0) === '/') return window.location.origin + url; return url; }
  function sized(url, width) { try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; } catch (error) { return absolute(url); } }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; }); }
  function normalizeColor(value) {
    var text = String(value || '').trim();
    return aliases[text.toLowerCase()] || text || 'Black';
  }
  function scriptUrl(file) {
    var own = Array.prototype.find.call(document.scripts, function (script) { return script.src && script.src.indexOf('dirtpaw-gallery-restore-20260713.js') !== -1; });
    if (own) return own.src.replace('dirtpaw-gallery-restore-20260713.js', file);
    return '/cdn/shop/t/16/assets/' + file;
  }
  function ensureStyle() {
    if (document.getElementById('dirtpaw-gallery-restore-style-20260713')) return;
    var style = document.createElement('style');
    style.id = 'dirtpaw-gallery-restore-style-20260713';
    style.textContent = '.auto-product[data-product-handle="' + handle + '"] [data-auto-visual-option-value] [data-auto-choice-label]{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-image{display:block;width:100%;height:100%}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-image img{display:block;width:100%;height:100%;object-fit:contain;background:#fff}.auto-product[data-product-handle="' + handle + '"] .auto-product__swatch-label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}';
    document.head.appendChild(style);
  }
  function selectedValue(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    return normalizeColor(checked ? checked.value : 'Black');
  }
  function groupFor(value) {
    return (groups[normalizeColor(value)] || groups.Black || []).map(function (id) { return entryById[id]; }).filter(Boolean);
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function setActiveThumb(root, activeId) {
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === activeId);
    });
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
    }
    wrap.appendChild(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      setActiveThumb(root, entry.id);
    };
    visibleIds[entry.id] = true;
  }
  function showGroup(root, value, preferredId) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(value);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[thumb.getAttribute('data-media-id')];
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }
    var active = entryById[preferredId] && visibleIds[preferredId] ? entryById[preferredId] : group[0];
    setMain(root, active);
    setActiveThumb(root, active.id);
  }
  function hydrateSwatches(root) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = normalizeColor(label.getAttribute('data-auto-visual-option-value') || '');
      var entry = groupFor(value)[0];
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = value;
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="78" height="78" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
    });
  }
  function replaceChart(root) {
    var url = scriptUrl(chartFile);
    var selector = 'img.auto-product__guide-image, img[src*="dirtpaw-combined-size-chart"]';
    root.querySelectorAll(selector).forEach(function (img) {
      img.src = url;
      img.srcset = '';
      img.width = 971;
      img.height = 1619;
      img.alt = 'Seibertron Dirtpaw adult and youth motocross gloves size chart with hand measurement method';
    });
  }
  function run() {
    var root = section();
    if (!root) return;
    ensureStyle();
    replaceChart(root);
    hydrateSwatches(root);
    showGroup(root, selectedValue(root));
    if (!root.dataset.dirtpawGalleryRestoreBound) {
      root.dataset.dirtpawGalleryRestoreBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          [0, 350, 900, 1600].forEach(function (delay) {
            window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceChart(root); }, delay);
          });
        }
      });
    }
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [80, 250, 600, 1000, 1500, 2200, 3200, 5000, 7500, 10000].forEach(function (delay) {
    window.setTimeout(run, delay);
  });
})();
